module.exports = __webpack_public_path__ + "img/cockroach_bluechart02.0d3134f8.jpg";